// this file is generated by update_shopify_store_data.py at 2026-02-23 20:27:19.571018
var courses = [
    {
        "course_id": "FD68102D-6CCF-EF11-9991-005056A7DAD4",
        "course_version": 1,
        "name": "Bias and Its Impact on Health",
        "course_type": 1,
        "author_information": "Dr. Melissa Desroches, Ph.D., RN, CNE",
        "description": "You will begin your exploration of implicit and explicit bias and its impact on health outcomes for adults with Intellectual and Developmental Disabilities. This content will be foundational to the development of your confidence and skills around caring for the population.",
        "learning_objectives_html": "By the time you complete this course, you will be able to:\r\n<ul>\r\n    <li>Describe implicit and explicit attitude formation and common misconceptions and biases</li>\r\n    <li>Identify care outcomes that occur due to these misconceptions</li>\r\n    <li>Explain challenges and ameliorative strategies for caring for hospitalized adults with IDD</li>\r\n    <li>Detail the specific issues with quality-of-life assumptions</li>\r\n    <li>Discuss how to apply the principles of culture competency to include disability and ID</li>\r\n</ul>",
        "course_outline_html": "none provided",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "B756B56E-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0C0B7090-D960-F011-99A0-005056A740BF",
                "course_category_name": "Golisano - Optimizing Care for Hospitalized Individuals with Intellectual and Developmental Disabilities - Courses",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6592CD9A-C7AC-4DD4-A98A-2D6483554821",
                "course_category_name": "CRRN: Rehabilitation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BDB7B074-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Registered Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B2501C7D-77CF-EF11-9993-005056A7D0C4",
                "course_category_name": "CNA: Certified Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B92FC0B9-AF4B-F011-99A4-005056A77B46",
                "course_category_name": "CE Unlimited_BRIDGE (No DEI Courses)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E429D0C-4610-EE11-997D-005056A730AF",
                "course_category_name": "Golisano",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FEB7B714-954B-46A4-89D6-628F916FB59B",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "162D7419-F1DE-4896-A447-ED5F2D41A1C1",
                "course_category_name": "CMSRN: Medical-Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "552455CB-0469-E811-B6FF-005056B10E33",
                "course_category_name": "CE Unlimited featuring Challenge Tracks",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F0D93E9B-C313-F011-999F-005056A77B46",
                "course_category_name": "Golisano-CEUnlimited",
                "is_system_course_category": null
            },
            {
                "course_category_id": "53A09CBA-47F5-41DE-ABBC-397BDE607DA7",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2F5C3339-BDD2-EB11-80E3-005056B142B5",
                "course_category_name": "Advance Practice Registered Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "",
            "course_level_accreditation_statement": "<em>The Golisano Institute for Developmental Disability Nursing is accredited as a provider of nursing continuing professional development by the American Nurses Credentialing Center&rsquo;s Commission on Accreditation. Provider Number P0691</em>",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 0.5,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];